import { addDays } from 'date-fns';
import { IsBefore } from 'utils';

const dateIsValid = (inDate: string, maxDateAge: number) => {
  return IsBefore(new Date(), addDays(new Date(inDate), maxDateAge));
};

export { dateIsValid };
